exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select[data-v-726377e2]{border:none;font-size:14px}", ""]);

// exports
